import { Request,BaseApiUrl } from "./api";
// 列表
export const getSysSyncMaterialMappingListPage = (params) => {
    return Request.get(`${BaseApiUrl}/api/SysSyncMaterialMapping/get`, { params: params });
  };
  
  
  //新增
  export const addSysSyncMaterialMapping = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysSyncMaterialMapping/Post`, params);
  };
  //编辑
  export const editSysSyncMaterialMapping = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysSyncMaterialMapping/Put`, params);
  };
  
  
  //批量删除
  export const batchDeleteSysSyncMaterialMapping = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysSyncMaterialMapping/BatchDelete`, params);
  };
  // export const batchDeleteSysSyncMaterialMapping = (params) => {
  //   return Request.delete(`${BaseApiUrl}/api/SysSyncMaterialMapping/BatchDelete`, {
  //     data: params,
  //     headers: {
  //       "Content-Type": "application/json-patch+json",
  //     },
  //   });
  // };
//基础信息
export const getSysSyncMaterialMappingBaseData = (params) => {
    return Request.get(`${BaseApiUrl}/api/SysSyncMaterialMapping/GetSyncMaterialMappingBaseData` );
};
// 生产线管理
// 列表
export const getSysStationLineListPage = (params) => {
    return Request.get(`${BaseApiUrl}/api/SysStationLine/get`, { params: params });
};